import { getMenuPage, getMenuList, updateMenu, delMenuById, getAccountMenu, updateAccountMenuRole } from '@/api/role'
import { login, getCurrUser, getCurrMenu } from '@/api/login'
import { message } from 'ant-design-vue'

export class RoleController {
  static async menuPage (params: COMMON.API.QueryParams) {
    const { code, data } = await getMenuPage(params)
    return {
      code,
      data: data.records,
      sum: data.total
    }
  }

  static async menuList () {
    return await getMenuList()
  }

  static async updateMenu (data: any) {
    const { code, msg } = await updateMenu(data)
    code === 0 ? message.success('更新成功') : message.error(msg)
  }

  static async delMenuById (id: string) {
    return await delMenuById(id)
  }

  static async accountMenu (userId: string) {
    return await getAccountMenu(userId)
  }

  static async updateAccountMenuRole (userId: string, data: any) {
    const { code, msg } = await updateAccountMenuRole(userId, data)
    code === 0 ? message.success('更新成功') : message.error(msg)
  }
}
